import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";

export default function EditScheduleRequestSummary() {
  const id = useParams().id?.toUpperCase()!;
  const { data: shipmentDetailsData } = useGetQuoteRequestDetails({
    shipmentId: id,
  });

  const { organization = {}, schedule = {} } = shipmentDetailsData ?? {};
  const { requestor, payment_location } = organization;
  const { pickup_city, pickup_state_code, pickup_country, stop1_city, stop1_state_code, stop1_country } = schedule;

  const requestSummaryData = [
    {
      title: <FormattedMessage id="general.shipper" defaultMessage="Shipper" />,
      content: requestor,
    },
    {
      title: (
        <FormattedMessage id="tracking.components.editScheduleDialog.paymentLocation" defaultMessage="Payment Location" />
      ),
      content: payment_location,
    },
    {
      title: (
        <FormattedMessage id="tracking.components.editScheduleDialog.pickupLocation" defaultMessage="Pickup location" />
      ),
      // Filter undefined to prevent unnecessary comma (,)
      content: [pickup_city, pickup_state_code, pickup_country].filter(Boolean).join(", "),
    },
    {
      title: (
        <FormattedMessage id="tracking.components.editScheduleDialog.deliveryLocation" defaultMessage="Delivery location" />
      ),
      content: [stop1_city, stop1_state_code, stop1_country].filter(Boolean).join(", "),
    },
    {
      title: <FormattedMessage id="general.team" defaultMessage="Team" />,
      content: requestor,
    },
  ];

  return (
    <>
      {requestSummaryData.map((data, i) => (
        <Row key={i}>
          <Col xs={3}>
            <p className="font-b3">{data.title}</p>
          </Col>
          <Col>
            <p className="font-b4 ">{data.content}</p>
          </Col>
        </Row>
      ))}
    </>
  );
}
